/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ConcertinaService {
    /**
     * Store for active items.
     */
    public activeItems: any[] = [];

    /**
     * Section is valid set next button as active.
     */
    public selectionChanged: Subject<any> = new Subject<any>();

    /**
     * Adds active items to the active items array
     * @param item
     */
    public addIndex(item): void {
        this.activeItems.push(item);
        this.selectionChanged.next(true);
    }

    /**
     * Removes active items from the active items array.
     * @param componentId
     */
    public removeIndex(componentId): void {
        const removeIndex = this.activeItems.findIndex(item => item.componentId === componentId);
        if (removeIndex !== -1) {
            this.activeItems.splice(removeIndex, 1);
        }
        this.selectionChanged.next(componentId);
    }
}
